import axios from "axios";
import { useState } from "react";

const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_PRESET;
// const cloud_name = 'deld8895x'
// const upload_preset = 'mhinzhlr'

export const uploadSingleFile = async (document) => {
  const formData = new FormData();
  formData.append("file", document);
  formData.append("upload_preset", UPLOAD_PRESET);

  try {
    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      formData
    );

    if (res.status === 200) {
      return res.data.url;
    }
  } catch (error) {
    console.log(error);
  }
};

const useFileUpload = () => {
  const [fileUrl, setFileUrl] = useState("");
  const [multiUrl, setMultiUrl] = useState([]);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  let file_urls = [];

  // get uploading progress
  const onUploadProgress = (event) => {
    const percentCompleted = Math.round((event.loaded * 100) / event.total);
    setProgress(percentCompleted);
  };

  // upload single file
  const singleFileUpload = async (document) => {
    if (progress === 100) {
      setProgress(1);
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("file", document);
    formData.append("upload_preset", UPLOAD_PRESET);

    try {
      setFileUrl("");
      const res = await axios.post(
        `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
        formData,
        { onUploadProgress }
      );
      if (res.status === 200) {
        setFileUrl(res.data.url);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // upload multiple file
  const multipleFileUpload = async (document) => {
    // push all axios request promise into a single array
    let files = Object.entries(document);
    files.map(async (file) => {
      const formData = new FormData();
      formData.append("file", file[1]);
      formData.append("tags", `tag_a, ${file[0]}`);
      formData.append("upload_preset", UPLOAD_PRESET);

      // Make an AJAX upload request using Axios
      try {
        const res = await axios.post(
          `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
          formData,
          { onUploadProgress }
        );
        if (res.status === 200) {
          let data = res.data;
          setMultiUrl(data.secure_url);
        }
      } catch (error) {}
      // const response = await axios.post(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, formData, {
      //     headers: { "X-Requested-With": "XMLHttpRequest" },
      //     onUploadProgress
      // })
      //     .then(response => {
      //         const data = response.data;
      //         const fileURL = data.secure_url;
      //         file_urls.push(data.tags[1] = fileURL);
      //         // setMultiUrl({...multiUrl, [name]: fileURL})
      //         setMultiUrl(file_urls)
      //         return fileURL;
      //     });
    });

    // Once all the files are uploaded
    // axios.all(uploaders).then((result) => {
    //     if(progress === 100){
    //         setProgress(0)
    //     }
    //     // ... perform after upload is successful operation
    // });
  };

  return {
    singleFileUpload,
    fileUrl,
    progress,
    loading,
    setProgress,
    multiUrl,
    multipleFileUpload,
    file_urls,
    setFileUrl,
  };
};

export default useFileUpload;
